import { Link } from 'react-router';

export default function HilfeCenterPage() {
  return (
    <main className="min-h-screen bg-warm-50 px-6 py-16 lg:px-8">
      <div className="mx-auto max-w-3xl rounded-2xl border border-warm-200/60 bg-white p-8 lg:p-10 shadow-[0_10px_28px_-16px_rgba(26,24,22,0.18)]">
        <h1 className="text-3xl font-semibold tracking-tight text-warm-800 mb-4">Hilfe-Center</h1>
        <p className="text-warm-600 leading-relaxed mb-6">
          Unterstützung für Onboarding, Nutzung und Datenschutzfragen. Unser Team antwortet werktags innerhalb kurzer Zeit.
        </p>
        <ul className="space-y-3 text-warm-700">
          <li>Onboarding & Einrichtung</li>
          <li>FAQ zu Funktionen und Workflows</li>
          <li>Support bei technischen Fragen</li>
          <li>Datenschutz- und AVV-Anfragen</li>
        </ul>
        <section id="onboarding-und-betrieb" className="mt-8 mb-6 scroll-mt-24">
          <h2 className="text-xl font-semibold text-warm-800 mb-2">Onboarding und Betrieb</h2>
          <p className="text-warm-600 leading-relaxed">
            Diese Hilfeseite dient als oeffentliche Referenz fuer den Landing-Hinweis "In 5 Min. startklar":
            Einrichtung, Ansprechpartner und Supportwege sind bereits vorhanden und muessen nicht ueber neue Routen erschlossen werden.
          </p>
        </section>
        <section id="sicherheits-und-compliance-hinweise" className="mb-6 scroll-mt-24">
          <h2 className="text-xl font-semibold text-warm-800 mb-2">Sicherheits- und Compliance-Hinweise</h2>
          <p className="text-warm-600 leading-relaxed">
            Fuer Trust- und Audit-Rueckfragen verweist die Landing hierhin: Support, Datenschutzanfragen,
            AVV-Prozess und weitere Pruefunterlagen werden ueber bestehende oeffentliche Kanaele gebuendelt.
          </p>
        </section>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href="mailto:support@getflowly.de?subject=Support-Anfrage" className="landing-cta-primary">Support kontaktieren</a>
          <Link to="/" className="landing-cta-secondary">Zur Landing Page</Link>
        </div>
      </div>
    </main>
  );
}
